import { call, put, takeEvery } from 'redux-saga/effects';
import { DataProviderInstance } from '../../@shared/services/DataProvider';
import { SchemaProviderInstance } from '../../@shared/services/SchemaProvider';
import { TrainedModelProviderInstance } from '../../@shared/services/TrainedModelProvider';
import { NotificationModel } from '../../reducers/main/mainModel';
import { onThrowAlert } from '../dataSaga/dataSagaActions';

import { initAction, isAuthorized } from './initSagaActions';
import { UserProviderInstance } from '../../@shared/services/UserProvider';
import RespondClient from '../../@shared/Models/RespondClient';
import { User } from '../../@shared/Models/Models';
import { setIsAuthorized, setUserIsLoading } from '../../reducers/main/mainReducer';

const initSaga = [
    takeEvery(initAction, watchInit),
    takeEvery(isAuthorized, watchIsAuthorized),
]


export default initSaga;

function* watchInit(): Generator {
    try {

        yield call([SchemaProviderInstance, SchemaProviderInstance.getInstance]);
        yield call([DataProviderInstance, DataProviderInstance.init]);
        yield call([TrainedModelProviderInstance, TrainedModelProviderInstance.init]);
    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
        console.log(error);
    }
}

function* watchIsAuthorized(): Generator {
    try {
        yield put(setUserIsLoading(true));
        const auth = (yield call([UserProviderInstance, UserProviderInstance.current])) as RespondClient<User>;
        if (auth.status === 200) {
            yield put(setIsAuthorized(auth.data));
        }
        else {
            yield put(setIsAuthorized(undefined));
        }


    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
        console.log(error);
    }
    finally {
        yield put(setUserIsLoading(false));
    }
}
